/* eslint-disable */
import {UPDATE_LOADING_STATUS, SET_LOADING_STATUS } from "@/state/actions-mutations-type";
const state = {
    loading: false
};
const getters = {
    isLoading(state) {
        return state.loading;
    }
};

const actions = {
    initStore({ state, dispatch }) {
    },
    [UPDATE_LOADING_STATUS]({ state, commit }, data) {
        //console.log("updating: ", UPDATE_LOADING_STATUS);
        commit(SET_LOADING_STATUS, data);
    },
};

const mutations = {
    [SET_LOADING_STATUS](state, value) {
        //console.log("value ", value);
        state.loading = value;
        //Object.assign(state, { loading: value });

    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



